
(() => {
  const nav=document.getElementById('nav');
  const update=()=>nav?.classList.toggle('stuck',scrollY>20);
  addEventListener('scroll',update,{passive:true});update();
  const image=document.querySelector('.intro-bottle');
  if(image&&'IntersectionObserver' in window){
    const observer=new IntersectionObserver(entries=>{
      if(entries.some(entry=>entry.isIntersecting)){
        if(!matchMedia('(prefers-reduced-motion: reduce)').matches)image.animate([{transform:'translateY(24px)',opacity:.35},{transform:'translateY(0)',opacity:1}],{duration:450,easing:'cubic-bezier(.23,1,.32,1)'});
        observer.disconnect();
      }
    },{threshold:.2});observer.observe(image);
  }
  document.addEventListener('keydown',event=>{if(event.key==='Escape'){document.getElementById('menu')?.classList.remove('open');document.getElementById('burger')?.setAttribute('aria-expanded','false');}});
})();

